import React from "react";
import {
  Box,
} from "@mui/material";
import Cookies from 'js-cookie';

import ViewMap from './map'
import ReadOnlyMovieMap from './read_only_map'
import { COOKIES_KEY, ROLE } from '../../const/general';

function View(props) {

  return (
    Cookies.get(COOKIES_KEY.ROLE) > ROLE.IS_STAFF ?
      <Box sx={{
        marginLeft: { xs: '0px', sm: '66px' },
      }} >
        <ViewMap
          contentsCount={props.contentsCount}
          setContentsCount={props.setContentsCount}
          searchConditions={props.searchConditions}
          setSearchConditions={props.setSearchConditions}
          selectTag={props.selectTag}
          setSelectTag={props.setSelectTag}
        />
      </Box>
      :
      <Box sx={{
        marginLeft: '0px'
      }} >
        <ReadOnlyMovieMap
          contentsCount={props.contentsCount}
          setContentsCount={props.setContentsCount}
          searchConditions={props.searchConditions}
          setSearchConditions={props.setSearchConditions}
          selectTag={props.selectTag}
          setSelectTag={props.setSelectTag}
        />
      </Box>
  )
}

export default View;
